<header class="mobile-top-bar">
  <button
    class="mobile-user-btn"
    type="button"
    (click)="openProfile.emit()"
    aria-label="Edit profile"
  >
    <div class="mobile-avatar">
      <app-user-avatar [name]="displayName()" [avatarUrl]="avatarUrl()" />
    </div>
  </button>

  <div class="mobile-brand">
    <svg
      viewBox="0 0 30 30"
      fill="none"
      width="30"
      height="30"
      aria-hidden="true"
    >
      <path
        d="M15 26C14 25 1 17 1 10C1 6 4.5 3 9 3C11.8 3 14 4.8 15 6.6C16 4.8 18.2 3 21 3C25.5 3 29 6 29 10C29 17 16 25 15 26Z"
        fill="url(#mb-hg)"
      />
      <path
        d="M15 11L16.2 14.2L19.5 15L16.2 15.8L15 19L13.8 15.8L10.5 15L13.8 14.2Z"
        fill="white"
        opacity="0.95"
      />
      <defs>
        <linearGradient
          id="mb-hg"
          x1="1"
          y1="3"
          x2="29"
          y2="26"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#f472b6" />
          <stop offset="0.5" stop-color="#c084fc" />
          <stop offset="1" stop-color="#818cf8" />
        </linearGradient>
      </defs>
    </svg>
    <span>{{ appName }}</span>
  </div>

  <button
    class="theme-toggle-btn"
    type="button"
    (click)="toggleDarkMode.emit()"
    [attr.aria-label]="
      darkMode() ? 'Switch to light mode' : 'Switch to dark mode'
    "
  >
    @if (darkMode()) {
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <circle cx="12" cy="12" r="4" />
        <path
          d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"
        />
      </svg>
    } @else {
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" />
      </svg>
    }
  </button>
</header>
